/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';

class TikTokOptions extends React.Component {
    render() {
        let currentPanel = null,
            constants = this.props.app.config.constants;

        if (this.props.activePanel !== 'advanced') {
            currentPanel = (
                <div>
                    {this.props.getTikTokFields()}
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        }

        return this.props.getPanelOutput(currentPanel);
    }

};

export default SocialPanelModule(TikTokOptions);
